import React from 'react';

import { VpHookFormInput } from '../../inputs';

export const FirstNameInput = () => {
  return <VpHookFormInput maxLength={50} required name="firstName" placeholder="First Name" />;
};

export default FirstNameInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/sign-up/FirstNameInput.jsx